var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgHeart = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 11,
  fill: "none",
  viewBox: "0 0 12 11",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.342.668C9.396-.005 8.358-.092 7.493.07a4.3 4.3 0 0 0-1.51.591A4.5 4.5 0 0 0 4.44.078C3.576-.078 2.527 0 1.62.678c-1.47 1.1-2 2.858-1.339 4.75.646 1.843 2.396 3.77 5.36 5.479a.7.7 0 0 0 .712-.01c3.254-2.008 4.943-4.019 5.467-5.847.541-1.887-.193-3.467-1.478-4.382"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeart);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };